import PaymentService from '../../lib/api/payment.service';

export async function fetchAllPaymentMethods({ commit }) {
  const response = await PaymentService.getAll();
  if (response.status === 200) {
    commit('updateAllPaymentMethods', { paymentMethods: response.data });
  }
}

export async function postPayment(context, { orderUuid, paymentMethodId, paymentData }) {
  const response = await PaymentService.payment({ orderUuid, paymentMethodId, paymentData });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function verifoneInit(context, { paymentMethodId }) {
  const response = await PaymentService.verifoneInit({ paymentMethodId });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function verifone3dSecure(context, { sessionId, paymentMethodId, orderUuid, encryptedCard, publicKeyAlias }) {
  const response = await PaymentService.verifone3dSecure({ sessionId, paymentMethodId, orderUuid, encryptedCard, publicKeyAlias });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function verifonePostPayment(context, { paymentMethodId, orderUuid, encryptedCard, publicKeyAlias, jwt, threedsLookupData }) {
  const response = await PaymentService.verifonePayment({ paymentMethodId, orderUuid, encryptedCard, publicKeyAlias, jwt, threedsLookupData });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}
